// ONE canonical slug charset for the embed (imported by index.tsx + AldeloFormEmbed.tsx).
// Must match the forms-api service.SlugPattern and the portal slug constant. (TD-249)
export const SLUG_RE = /^[a-z][a-z0-9_-]{0,47}$/;
